// src/services/auth.service.js
import jwtDecode from 'jwt-decode';

const TOKEN_KEY = 'auth_token';
const USER_KEY = 'auth_user';

export default {
  // Enregistrer le token et les données utilisateur dans le localStorage
  setToken(token, user) {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  
  // Récupérer le token depuis le localStorage
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },
  
  // Récupérer les données utilisateur depuis le localStorage
  getUser() {
    const userStr = localStorage.getItem(USER_KEY);
    return userStr ? JSON.parse(userStr) : null;
  },
  
  // Supprimer le token et les données utilisateur du localStorage
  clearToken() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },
  
  // Vérifier si l'utilisateur est authentifié
  isAuthenticated() {
    const token = this.getToken();
    if (!token) {
      return false;
    }
    
    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      
      // Vérifier si le token n'est pas expiré
      return decoded.exp > currentTime;
    } catch (error) {
      return false;
    }
  },
  
  // Vérifier si l'utilisateur est un administrateur
  isAdmin() {
    if (!this.isAuthenticated()) {
      return false;
    }
    
    const user = this.getUser();
    return user && user.role === 'admin';
  },
  
  // Vérifier si l'utilisateur est un client
  isClient() {
    if (!this.isAuthenticated()) {
      return false;
    }
    
    const user = this.getUser();
    return user && user.role === 'client';
  }
};